console.log("Hello, Wandering Wayfarer!");

/** Typewriter effect for homepage banner footer. */
import Typewriter from 'typewriter-effect/dist/core';

if (document.getElementById('dynamic-typewriter-text')) {
  new Typewriter('#dynamic-typewriter-text', {
    strings: ['less stressful', 'easier', 'simpler', 'faster', 'more affordable'],
    autoStart: true,
    loop: true,
  });
}


/** Accordion customizations */
function addPlusToAccordion() {
  $('.wayfarer-accordion .accordion-title').append('<span class="wayfarer-plus">&#43;</span>');
}

addPlusToAccordion();

function removeTopBarFromAccordion() {
  $('.accordion').each(function () {
    $(this).find('.accordion-title.plain').first().css({"borderTop": "none"})
  });
}

removeTopBarFromAccordion();

/** Ensure after #top-link is clicked, .stuck class is added back to header */
function overrideScrollTop() {
  $( "#top-link" ).click(function(event) {
    setTimeout(() => {
      $('.header-wrapper').addClass('stuck');
    }, 500);
  });
}

overrideScrollTop();

/** Dropdown logic for filter bar */

$('#wayfarer-filter-bar').on('click', function(){
  $('#wayfarer-dropdown-menu').toggleClass('wayfarer-show');
  $('#wayfarer-filter-bar').toggleClass('wayfarer-open');
});

/** Shop Van Pages - Scroll Subnav Links Into View */
function scrollSubNavLinksIntoView() {
  $( "#subnav-overview" ).click(function(event) {
    const subNavOverview = document.getElementById("scroll-to-overview");
    subNavOverview.scrollIntoView({ behavior: "smooth" });
  });

  $( "#subnav-bragging-rights" ).click(function(event) {
    const subNavOverview = document.getElementById("scroll-to-bragging-rights");
    subNavOverview.scrollIntoView({ behavior: "smooth" });
  });

  $( "#subnav-vehicle" ).click(function(event) {
    const subNavOverview = document.getElementById("scroll-to-vehicle");
    subNavOverview.scrollIntoView({ behavior: "smooth" });
  });

  $( "#subnav-options" ).click(function(event) {
    const subNavOverview = document.getElementById("scroll-to-options");
    subNavOverview.scrollIntoView({ behavior: "smooth" });
  });

  $( "#subnav-specs" ).click(function(event) {
    const subNavOverview = document.getElementById("scroll-to-specs");
    subNavOverview.scrollIntoView({ behavior: "smooth" });
  });
}

scrollSubNavLinksIntoView();

/** Add search image to light box */
function addSearchToLightBox() {
  $(".image-lightbox .img-inner").append("<i class='fa fa-search'></i>");
}
addSearchToLightBox();

/** Replace Woocommerce Expand Icon */
function replaceIonicWoocommerceExpandIcon() {
  $(".iconic-woothumbs-icon.iconic-woothumbs-icon-fullscreen")
    .addClass("fa fa-search")
    .removeClass("iconic-woothumbs-icon")
    .removeClass("iconic-woothumbs-icon-fullscreen");
}
replaceIonicWoocommerceExpandIcon();

/** Replace first name in accessories page dropdown. */
function replaceAccessoriesPlaceholderName() {
  $(".chosen-container-single .chosen-single span").replaceWith('<span>Choose Your Van</span>');
}
function replaceAccessoriesDropdownName() {
  const element = $(".chosen-container-single");
  $(".chosen-container-single").click(function() {
    $(".chosen-results .active-result").first().replaceWith('<li class="active-result">Choose Your Van</li>');
  })
}
// Delay running so the page is loaded
setTimeout(() => {
  replaceAccessoriesPlaceholderName();
  replaceAccessoriesDropdownName();
}, 250);

function preserveUTMQueryParams() {
  const query = window.location.search;
  if (!query) return;

  // Select all internal anchor tags (not external or hash links)
  document.querySelectorAll('a[href]').forEach(link => {
    const href = link.getAttribute('href');
    // Skip if external, anchor, or already has query params
    if (
      href.startsWith('http') && !href.startsWith(window.location.origin) ||
      href.startsWith('#') ||
      href.startsWith('mailto:') ||
      href.startsWith('tel:') ||
      href.includes('?') ||
      !query.includes('utm_') // Skip if query params are NOT UTM
    ) {
      return;
    }
    // Append query params
    link.setAttribute('href', href + query);
  });
};

preserveUTMQueryParams();


